export type Voice = {
  quote: string
  source: string
  /** Dónde lo resuelve el pack. */
  answer?: string
}

/** Lo que los coaches dicen que necesitan. */
export const painVoices: Voice[] = [
  {
    quote:
      'Before, I spent hours trying to figure out what to run at each practice. Having the sessions organized into clear blocks would make it much easier to walk onto the field with a plan and focus on coaching instead of planning.',
    source: 'Sarah M. — Austin, Texas, USA',
    answer: '43 practices already written on the 4-Block Practice System.',
  },
  {
    quote:
      'With a team full of beginners, I need practices that keep everyone moving while we build the fundamentals. Having drills organized by skill and difficulty would help me spend less time figuring out what comes next.',
    source: 'Emily J. — Phoenix, Arizona, USA',
    answer:
      'Drills organized by skill, each with how to make it easier or harder.',
  },
  {
    quote:
      'I volunteer because I love helping the girls learn, but planning every practice on top of everything else can be overwhelming. A ready-to-use practice structure would give me a clearer starting point each week.',
    source: 'Jessica B. — San Diego, California, USA',
    answer: 'A ready-to-run practice structure you print and use every week.',
  },
]

/** Cómo lo usan los coaches. */
export const wantVoices: Voice[] = [
  {
    quote:
      'I use it alongside my club’s practice structure to add variety to our skill work without replacing the fundamentals we already teach.',
    source: 'Brian K. — Chicago, Illinois, USA',
  },
  {
    quote:
      'Our team uses the ready-to-run sessions as a starting point, then adapts the drills to our players’ ages and experience levels.',
    source: 'Amanda C. — Tampa, Florida, USA',
  },
  {
    quote:
      'I use the four-block structure to organize our practices while keeping our existing team goals and coaching priorities.',
    source: 'Lauren W. — Charlotte, North Carolina, USA',
  },
]
